import {ObjectWrapperFactory} from 'md-library-test-first-version';

export const Providers = [
    ObjectWrapperFactory
];
